import { v4 } from 'uuid'

import { createSelector } from '@app/utils/createSelector'

import type { V3GetSupportEventsResponse } from '@app/packages/api/v3/types/responses'
import { createLoadable } from '@app/packages/thunkSelector/thunkSelector'
import type { SliceState } from '@app/packages/thunkSelector/withCheckedSliceState'
import { withCheckedSliceState } from '@app/packages/thunkSelector/withCheckedSliceState'

import { callApi } from '@app/store/actions/api'
import { createReduxSlice } from '@app/store/redux_slice'
import { profileUserIdSelector } from '@app/store/selectors/profile'
import { createThunk } from '@app/store/thunk'

import { invalidateAccountIssues } from './account_issues'

const supportEventsSyncSlice = createReduxSlice<{ hash: string }>('support_events_sync')

const supportEventsSlice = createReduxSlice<SliceState<V3GetSupportEventsResponse>>('support_events')

export const supportEventsResultSelector = createSelector(
  [supportEventsSlice.selector, supportEventsSyncSlice.selector, profileUserIdSelector],
  (slice, sync, profileUserId) =>
    createLoadable(c =>
      withCheckedSliceState(c, {
        sliceState: slice,
        slice: supportEventsSlice,
        hash: [profileUserId ?? '', sync?.hash ?? 'initial'].join(':'),
        load: async dispatch => {
          const { getSupportEvents } = await import('@app/packages/api/v3/actions/support_events')
          return await dispatch(callApi(getSupportEvents({ event_types: ['support_day'] })))
        },
      })
    )
)

export const invalidateSupportEvents = () => supportEventsSyncSlice.set({ hash: v4() })

export const postSupportEventRegistration = (id: string) =>
  createThunk(async dispatch => {
    const { postSupportEventRegistration: v3PostSupportEventRegistration } = await import('@app/packages/api/v3/actions/support_events')
    const result = await dispatch(callApi(v3PostSupportEventRegistration(id)))
    dispatch(invalidateSupportEvents())
    dispatch(invalidateAccountIssues())
    return result
  })

export const deleteSupportEventRegistration = (id: string) =>
  createThunk(async dispatch => {
    const { deleteSupportEventRegistration: v3DeleteSupportEventRegistration } = await import('@app/packages/api/v3/actions/support_events')
    const result = await dispatch(callApi(v3DeleteSupportEventRegistration(id)))
    dispatch(invalidateSupportEvents())
    dispatch(invalidateAccountIssues())
    return result
  })
